import { Injectable } from '@angular/core';
import { HttpContentType } from '@digitaltoolbuilders/iso';
import { AttachmentCreatedPayload } from '@sko/models';
import { get, post } from 'aws-amplify/api';
import { IncomingPhoneNumberInstance, IncomingPhoneNumberListInstance } from 'twilio/lib/rest/api/v2010/account/incomingPhoneNumber';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor() { }

  createAttachement(content_type: HttpContentType, content_length: number) {

    return post({
      apiName: 'default',
      options: {
        body: {
          content_length,
          content_type,
        },
      },
      path: '/messages/create-attachment',
    })
    .response
    .then((response) => {

      return response.body.json();

    })
    .then((payload) => {

      return payload as unknown as AttachmentCreatedPayload;

    });

  }

  listPhoneNumbers() {

    return get({
      apiName: 'default',
      path: '/phone-numbers',
    })
    .response
    .then((response) => {

      return response.body.json();

    })
    .then((payload) => {

      const result = payload as unknown as Array<IncomingPhoneNumberInstance>;

      return result;

    });

  }

  uploadAttachment(url: string, file: File) {

    return fetch(url, {
      body: file,
      headers: {
        'Content-Type': file.type,
      },
      method: 'PUT',
    });

  }

}
